import { useEffect, useMemo, useState } from 'react';
import { onSnapshot } from 'firebase/firestore';
import {
  buildLeaveAllocationsQuery,
  mapLeaveAllocationSnapshot,
} from '../services/leaveService';
import { LeaveAllocationFilter, LeaveAllocationRecord, UseLeaveAllocationsResult } from '../types';

export const useLeaveAllocations = (filter: LeaveAllocationFilter | null): UseLeaveAllocationsResult => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const [data, setData] = useState<LeaveAllocationRecord[]>([]);

  const normalisedFilter = useMemo(() => {
    if (!filter || !filter.year || Number.isNaN(filter.year)) {
      return null;
    }
    return filter;
  }, [filter?.role, filter?.uid, filter?.managerLocations, filter?.year]);

  useEffect(() => {
    if (!normalisedFilter) {
      setData([]);
      setLoading(false);
      setError(null);
      return undefined;
    }

    setLoading(true);
    setError(null);

    const allocationsQuery = buildLeaveAllocationsQuery(normalisedFilter);

    const unsubscribe = onSnapshot(
      allocationsQuery,
      (snapshot) => {
        const mapped = snapshot.docs.map(mapLeaveAllocationSnapshot);
        setData(mapped);
        setLoading(false);
      },
      (snapshotError) => {
        console.error('Error subscribing to leave allocations:', snapshotError);
        setError(snapshotError as Error);
        setLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [normalisedFilter]);

  return { data, loading, error };
};
